var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewTabArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-M---SFY---PDP-Final",
    transform: "translate(-347.000000, -539.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(19.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(245.000000, 89.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.265896,4.25433526 L83.6242775,10.8959538 C83.4797688,11.0346821 83.2485549,11.0346821 83.1040462,10.8959538 C82.9653179,10.7514451 82.9653179,10.5202312 83.1040462,10.3757225 L89.7456647,3.73410405 L86.0231214,3.73410405 C85.8208092,3.73410405 85.6589595,3.56647399 85.6589595,3.36416185 C85.6589595,3.16184971 85.8208092,3 86.0231214,3 L91,3 L91,7.97687861 C91,8.17919075 90.8381503,8.34104046 90.6358382,8.34104046 C90.433526,8.34104046 90.265896,8.17919075 90.265896,7.97687861 L90.265896,4.25433526 Z",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTabArrow);
export default __webpack_public_path__ + "static/media/new_tab_arrow.b028631d64ab4da8859ac07dbf7c99de.svg";
export { ForwardRef as ReactComponent };